










import Vue from 'vue';
import { openModal } from 'mycorems-app-shared';
import isGranted from '../auth/isGranted';
import { PaymentMethod } from '../types';
import DeletePaymentMethodModal from './DeletePaymentMethodModal.vue';

export default Vue.extend({
  props: {
    paymentMethod: {
      type: Object as () => PaymentMethod,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { paymentMethod: this.paymentMethod, parent: this };
      openModal(DeletePaymentMethodModal, props).onOk(() => {
        this.$emit('deleted');
      });
    },
    isGranted,
  },
});
